var _g, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrossIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5563_70619)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(1 0 0 -1 12 34)",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8242 17.0308C29.9368 16.9167 30 16.7627 30 16.6021C30 16.4415 29.9368 16.2875 29.8242 16.1734C29.7096 16.0622 29.5564 16 29.397 16C29.2375 16 29.0843 16.0622 28.9697 16.1734L24 21.1676L19.0303 16.1734C18.9157 16.0622 18.7625 16 18.603 16C18.4436 16 18.2904 16.0622 18.1758 16.1734C18.0632 16.2875 18 16.4415 18 16.6021C18 16.7627 18.0632 16.9167 18.1758 17.0308L23.153 22.0175L18.1758 27.0043C18.0802 27.1212 18.0313 27.2696 18.0387 27.4206C18.0461 27.5717 18.1092 27.7146 18.2158 27.8216C18.3224 27.9285 18.4648 27.9918 18.6153 27.9993C18.7659 28.0067 18.9138 27.9577 19.0303 27.8617L24 22.8675L28.9697 27.8617C29.0862 27.9577 29.2341 28.0067 29.3847 27.9993C29.5352 27.9918 29.6776 27.9285 29.7842 27.8216C29.8908 27.7146 29.9539 27.5717 29.9613 27.4206C29.9687 27.2696 29.9198 27.1212 29.8242 27.0043L24.847 22.0175L29.8242 17.0308Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5563_70619",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5563_70619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5563_70619",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon2);
export default __webpack_public_path__ + "static/media/crossIcon2.a2e7fb0ad1bd90efa847146193f4c99e.svg";
export { ForwardRef as ReactComponent };